/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDatabase = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 18c0 2.748-5.184 4-10 4S2 20.748 2 18V6c0-2.748 5.184-4 10-4 4.723 0 9.8 1.204 9.994 3.843L22 6zM4 14.529V18c0 .514 2.751 2 8 2s8-1.486 8-2v-3.286C18.325 15.587 15.768 16 13 16c-.167 0-.336-.001-.506-.004-.166.002-.33.004-.494.004-2.956 0-6.051-.471-8-1.471zm15.785-5.895-.104.05a10.239 10.239 0 0 1-1.298.485 14.827 14.827 0 0 1-.979.262l-.06.014-.188.042-.11.023-.123.026a20.293 20.293 0 0 1-.797.146c-.352.057-.71.106-1.073.148l-.098.01a24.727 24.727 0 0 1-.368.039l-.065.006a31.16 31.16 0 0 1-.76.06l-.115.006c-.235.014-.47.025-.707.033l-.164.005-.171.004-.171.004L12 10c-2.956 0-6.05-.472-8-1.471v3.47c0 .515 2.751 2 8 2s8-1.485 8-2V8.53l-.04.02-.1.05-.018.008L20 8.53zM12 4C6.873 4 4.13 5.418 4.004 5.963L4 6c0 .514 2.751 2 8 2s8-1.486 8-2-2.751-2-8-2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgDatabase as Database };
